import React from "react";
import { connect } from "react-redux";
import {
  Paper,
  Divider,
  TextField,
  Box,
  FormControl,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import SearchIcon from "@material-ui/icons/Search";
import { DoctorAction } from "../../../redux/actions/DoctorAction";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
    margin: theme.spacing(1),
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const SearchDoctorFilter = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <Paper elevation={0}>
      <Box display="flex" justifyContent="flex-start" m={1} p={1}>
        <Helmet>
          <title>Patient portal | Appointment</title>
        </Helmet>
        <Box style={{ width: "100%" }}>
          <Formik
            enableReinitialize
            initialValues={{
              startDateTime: props.startDateTime?props.startDateTime:'',
            }}
            validationSchema={Yup.object().shape({
              startDateTime: Yup.date().required(
                "Appointment date & time is required"
              ),
            })}
            onSubmit={(values, { setSubmitting }) => {
              props.handleSearchDoctor(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
            }) => (
              <>
                <Box
                  component="div"
                  className={classes.root}
                  style={{ width: "100%" }}
                >
                  <form
                    className={classes.root}
                    onSubmit={handleSubmit}
                    noValidate
                    name="form"
                    style={{ width: "100%" }}
                  >
                    <FormControl margin="normal" style={{ width: "100%" }}>
                      <TextField
                        error={Boolean(
                          touched.startDateTime && errors.startDateTime
                        )}
                        helperText={
                          touched.startDateTime && errors.startDateTime
                        }
                        id="startDateTime"
                        name="startDateTime"
                        label="Appointment date & time"
                        type="datetime-local"
                        className={classes.textField}
                        onBlur={e => {
                          handleBlur(e);
                          props.handleDateChange(e);
                      }}
                        onChange={handleChange}
                        value={values.startDateTime}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </FormControl>
                    <Divider
                      className={classes.divider}
                      orientation="vertical"
                    />
                    <IconButton
                      type="submit"
                      color="primary"
                      className={classes.iconButton}
                      aria-label="search doctor"
                    >
                      <SearchIcon />
                    </IconButton>
                  </form>
                </Box>
              </>
            )}
          </Formik>
        </Box>
      </Box>
    </Paper>
  );
};
export default SearchDoctorFilter;
